var temp_ent = [];
export const mutations = {
   setEntreatyDetail: function (state, detail) {
    state.ent_detail = detail;
  },
  
  setEntAll: function (state, { entAll, entPro }) {
    const ent_all = [...entAll].filter(
      (e) => e.ent_status.to_status_code !== "DRAFT"
    );
    for (var i = ent_all.length - 1; i >= 0; i--) {
      for (var j = 0; j < state.ent_pro.length; j++) {
        if (ent_all[i] && ent_all[i].ent_id === state.ent_pro[j].ent_id) {
          ent_all.splice(i, 1);
        }
      }
    }
    state.ent_all = ent_all;
    temp_ent = [...ent_all];
  },
  setEntWaiting: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.UpdatedAt = new Date(d.UpdatedAt.substring(0,10));
      return d;
    });
    state.ent_waiting = tmp;
  },
  setEntProcess: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.UpdatedAt = new Date(d.UpdatedAt.substring(0,10));
      return d;
    });
    state.ent_pro = tmp;
  },
  setEntDone: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.ApproveDate = new Date(d.ApproveDate.substring(0,10));
      d.ExpireDate = new Date(d.ExpireDate.substring(0,10));
      return d;
    });
    state.ent_done = tmp;
  },
  setEntPaid: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.ApproveDate = new Date(d.ApproveDate.substring(0,10));
      d.ExpireDate = new Date(d.ExpireDate.substring(0,10));
      d.PaidDate = new Date(d.PaidDate.substring(0,10));
      return d;
    });
    state.ent_paid = tmp;
  },
  setEntHandover: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.ApproveDate = new Date(d.ApproveDate.substring(0,10));
      d.ExpireDate = new Date(d.ExpireDate.substring(0,10));
      d.HandoverDate = new Date(d.HandoverDate.substring(0,10));
      return d;
    });
    state.ent_handover = tmp;
  },
  setSortProcess: function (state, ent) {
    state.sort_pro = [...ent];
  },
  setEntPiad: function (state, ent) {
    state.ent_paid = ent;
  },
  setEntView: function (state, ent) {
    state.ent_view = ent;
    state.ent_has_application = !!ent.application;
    state.ent_has_attorney = !!ent.attorney;
    let checkSec004 = ![...ent.categories].map((e) => e.category.ent_sec_code == "se004").includes(false);
    state.ent_has_certificate = checkSec004;
  },
  setListStatusEnt: function (state, status) {
    // console.log(status.status_code);
    var next_Statuses = [];
    if(status.status_code == "TXN_WAITING") {
      next_Statuses = [...status.next_Statuses].filter(e => e.status_code != "PAID_TXN");
    } else {
      next_Statuses = [...status.next_Statuses];
    }
    state.next_Statuses = next_Statuses;
    state.next_status = status.next_status;
    state.status_code = status.status_code;
  },
  setEntreatyTimeline: function (state, timeline) {
    state.ent_timeline = timeline;
  },
  clearBookMark: function (state, id) {
    const index = [...state.ent_pro].findIndex((e) => e.ent_id === id);
    if (index > -1) {
      state.ent_pro.splice(index, 1);
    }
  },
  removeOneEntAll: function (state, id) {
    const index = [...state.ent_all].findIndex((e) => e.ent_id === id);
    if (index > -1) {
      state.ent_all.splice(index, 1);
    }
  },
  search: function (state, str) {
    const items = [];
    for (const iterator of temp_ent) {
      if (
        iterator.company_name.includes(str) ||
        iterator.action_type.includes(str) ||
        iterator.category.cate_name.includes(str) ||
        iterator.category.sector.ent_sec_description.includes(str)
      ) {
        items.push(iterator);
      }
    }

    state.ent_all = items;
  },
  sortBySector: function (state, sec_code) {
    const items = [];
    for (const iterator of temp_ent) {
      if (iterator.category.ent_sec_code == sec_code) {
        items.push(iterator);
      }
    }

    state.ent_all = items;
  },
  sortByCate: function (state, { sec_code, cate_id }) {
    const items = [];
    for (const iterator of temp_ent) {
      if (
        iterator.category.ent_sec_code == sec_code &&
        iterator.category.cate_id == cate_id
      ) {
        items.push(iterator);
      }
    }

    state.ent_all = items;
  },
   setSelectedFee: function (state, data) {
    state.selected_fee = [data];
  },
  setApplication: function (state, application) {
    state.ent_has_application = true;
    state.ent_application.ent_id = application.ent_id;
    state.ent_application.created_at = application.created_at;
    state.ent_application.first_name = application.first_name;
    state.ent_application.surname = application.surname;
    state.ent_application.birthdate = application.birthdate;
    state.ent_application.address_id = application.address_id;
    state.ent_application.village = application.village;
    state.ent_application.district = application.district;
    state.ent_application.province = application.province;
    state.ent_application.nationality = application.nationality;
    state.ent_application.personal_no = application.personal_no;
    state.ent_application.passport_no = application.passport_no;
    state.ent_application.gender = application.gender;
    state.ent_application.office_name_la = application.office_name_la;
    state.ent_application.office_name_en = application.office_name_en;
    state.ent_application.business_type = application.business_type;
  },

  setAttorney: function (state, attorney) {
    state.ent_has_attorney = true;
    state.ent_attorney.ent_id = attorney.ent_id;
    state.ent_attorney.version_no = attorney.version_no;
    state.ent_attorney.created_at = attorney.created_at;
    state.ent_attorney.g_first_name = attorney.g_first_name;
    state.ent_attorney.g_surname = attorney.g_surname;
    state.ent_attorney.g_age = attorney.g_age;
    state.ent_attorney.g_work = attorney.g_work;
    state.ent_attorney.g_position = attorney.g_position;
    state.ent_attorney.g_duty = attorney.g_duty;
    state.ent_attorney.g_home_no = attorney.g_home_no;
    state.ent_attorney.g_group_no = attorney.g_group_no;
    state.ent_attorney.g_address_id = attorney.g_address_id;
    state.ent_attorney.g_village = attorney.g_village;
    state.ent_attorney.g_district = attorney.g_district;
    state.ent_attorney.g_province = attorney.g_province;
    state.ent_attorney.g_credit_type = attorney.g_credit_type;
    state.ent_attorney.g_credit_no = attorney.g_credit_no;
    state.ent_attorney.g_credit_start = attorney.g_credit_start;
    state.ent_attorney.g_credit_end = attorney.g_credit_end;
    state.ent_attorney.g_credit_by = attorney.g_credit_by;
    state.ent_attorney.g_place = attorney.g_place;
    state.ent_attorney.g_tell = attorney.g_tell;
    state.ent_attorney.g_email = attorney.g_email;
    state.ent_attorney.r_first_name = attorney.r_first_name;
    state.ent_attorney.r_surname = attorney.r_surname;
    state.ent_attorney.r_age = attorney.r_age;
    state.ent_attorney.r_work = attorney.r_work;
    state.ent_attorney.r_position = attorney.r_position;
    state.ent_attorney.r_duty = attorney.r_duty;
    state.ent_attorney.r_home_no = attorney.r_home_no;
    state.ent_attorney.r_group_no = attorney.r_group_no;
    state.ent_attorney.r_address_id = attorney.r_address_id;
    state.ent_attorney.r_village = attorney.r_village;
    state.ent_attorney.r_district = attorney.r_district;
    state.ent_attorney.r_province = attorney.r_province;
    state.ent_attorney.r_credit_type = attorney.r_credit_type;
    state.ent_attorney.r_credit_no = attorney.r_credit_no;
    state.ent_attorney.r_credit_start = attorney.r_credit_start;
    state.ent_attorney.r_credit_end = attorney.r_credit_end;
    state.ent_attorney.r_credit_by = attorney.r_credit_by;
    state.ent_attorney.r_tell = attorney.r_tell;
    state.ent_attorney.r_email = attorney.r_email;
  },
};
